import type { ServiceFeeCarrier } from '@src/domains/service-fees/types/serviceFee';

export const getServiceFeeDescriptions = (items: ServiceFeeCarrier[]): string[] => {
  const descriptions = items
    .map((item) => item.serviceFee?.description)
    .filter((description): description is string => Boolean(description));

  return [...new Set(descriptions)];
};
